import { Component, OnInit, AfterViewInit, ViewEncapsulation, Input, HostListener } from '@angular/core';
import { Helpers } from "../../../../helpers";
import { Router } from '@angular/router'
import { MainService } from '../../../service/main.service';
import { session } from '../../../../../environments/environment.session'
import { AuthenticationService } from '../../../../authentication.service';
import { MainService as portal_mainService } from '../../../../portal/service/main.service';
import { UtilityService } from '../../service/utility.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements OnInit {



  @Input({ required: true }) configurationObj: any | undefined;
  sidebarCollapsed: boolean = false;

  constructor(public auth: AuthenticationService,
    //  private settingService: SettingService, 
    private mainService: MainService, private router: Router,
    //  private utilityService:UtilityService
    private portal_mainService: portal_mainService,
    private utilityService: UtilityService,
    private utf8EncodingService: Utf8EncodingService

  ) { 
    if(window.innerWidth<901){
      this.sidebarCollapsed = true;
    }
  }
  b_acct_id: any = -1;
  erpUser: any;
  allFields: any = [];
  allCodeValue: any = [];
  codeValueObj: any = {};
  codeValueTechObj: any = {};
  codeValueShowObj: any = {};


  async ngOnInit() {

    console.log(this.configurationObj);
    this.utilityService.configObj = this.configurationObj;
    console.log('from common ', this.configurationObj,
    );

    // this.utilityService.configObj.subscribe((item:any)=>{
    //   console.log(item);

    // })

    // this.utilityService.setData(this.configurationObj)


    if (session.erpUser == undefined || session.erpUser == null) {
      this.router.navigate(['/login']);
    } else {
      this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
      this.b_acct_id = this.erpUser.b_acct_id

    }
    await this.getAllTaskOfUser()
    await this.getCodeValue();
    await this.getAllLanguage();
    // await this.mainService.getAllLanguages(JSON.stringify({}))
    // await this.getAllLabel({ component_cd: null, module_cd: [this.configurationObj.module_cd] })
    await this.getAllLabel({ component_cd: null, module_cd: ['EMB'] })
  }


  allLanguage: any = []
  language_cd: any
  async getAllLanguage() {
    var obj = new Object();
    var resp = await this.mainService.getAllLanguages(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allLanguage = resp.data;
      this.language_cd = this.auth.language_cd
    } else {

    }
  }

  async getAllTaskOfUser() {
    var obj: any = Object()
    obj['b_acct_id'] = this.erpUser.b_acct_id
    obj['user_id'] = this.erpUser.user_id
    obj["status"] = 'PENDING'
    var resp = await this.mainService.getAllTaskOfUser(JSON.stringify(obj))
    if (resp['error'] == false) {
      // this.utilityService.count = resp['data'].length
      this.portal_mainService.count = resp['data'].length
    } else {
    }
  }

  onSidebarState(value: boolean) {
  this.sidebarCollapsed = value;
}


  async getCodeValue() {
    let obj = { b_acct_id: this.b_acct_id, module_cd: this.configurationObj.module_cd }
    var resp = await this.mainService.getCodeValue(JSON.stringify(obj));
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.codeValueObj = codeValueTempObj;
      this.codeValueShowObj = codeValueShowTempObj;
      this.mainService.codeValueTechObj = this.codeValueObj;
      this.mainService.codeValueShowObj = this.codeValueShowObj;

    } else {

    }

  }
  ngAfterViewInit() {
    Helpers.initLayout();
  }



  count: any = 0
  allLableShowObj: any = {}
  allLabel: any = []
  async getAllLabel(obj: any) {
    // var obj: any = new Object();
    //obj['module_cd'] = 'MD'
    var resp = await this.mainService.getcomponentLabelvalueswithLanguage(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allLabel = resp.data;

      obj = {}
      for (let i = 0; i < resp.data.length; i++) {
        obj[resp.data[i]['language_cd'] + resp.data[i]['component_cd'] + resp.data[i]['label_no']] = resp.data[i]['value_to_show'];
      }


      this.allLableShowObj = { ...this.allLableShowObj, ...obj };


      this.mainService.allLableShowObj = { ...this.allLableShowObj, ...obj };

    } else {

    }
  }
}



